import { inject, Injectable } from '@angular/core';
import { FundraiserMinimal } from '@fmnts/api';
import { FundraiserNextApi } from '@fmnts/api/next';
import { LegacyStore } from '@formunauts/next/data-access';
import { catchError, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FundraiserStore {
  private fundraiserApi = inject(FundraiserNextApi);
  private store = inject(LegacyStore);

  public readonly self$ = this.store.select<FundraiserMinimal>(
    'next.fundraisers.self',
  );
  retrieveSelf(): Observable<FundraiserMinimal> {
    return this.get('self');
  }

  get(id: string): Observable<FundraiserMinimal> {
    return this.fundraiserApi.get(id).pipe(
      tap((next) => this.store.set(`next.fundraisers.${id}`, next)),
      catchError((e) => {
        console.error(e);
        throw e;
      }),
    );
  }
}
